import {CheckIcon, CommentIcon, DotFillIcon, FileDiffIcon} from '@primer/octicons-react'
import type {Icon} from '@primer/octicons-react'
import {
  DeferredType,
  type PendingReviewRequest,
  ReviewState,
} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'
import {dismissedReviewLabel} from '../../../helpers/review-state-labels'

export function reviewState(
  state: ReviewState,
  dismissedState: ReviewState = ReviewState.UNSPECIFIED,
): {icon: Icon; className: string} {
  switch (state) {
    case ReviewState.APPROVED:
      return {icon: CheckIcon, className: 'color-fg-success'}
    case ReviewState.CHANGES_REQUESTED:
      return {icon: FileDiffIcon, className: 'color-fg-danger'}
    case ReviewState.COMMENTED:
      return {icon: CommentIcon, className: 'color-fg-muted'}
    case ReviewState.DISMISSED: {
      const dismissedReviewState = reviewState(dismissedState)
      return {
        icon: dismissedReviewState.icon,
        className: 'color-fg-muted',
      }
    }
    case ReviewState.PENDING:
      return {icon: DotFillIcon, className: 'color-fg-attention'}
    case ReviewState.UNSPECIFIED:
      return {icon: DotFillIcon, className: 'color-fg-muted'}
  }
}

export function reviewStateTooltip(
  state: ReviewState,
  name: string,
  dismissedState: ReviewState = ReviewState.UNSPECIFIED,
): string {
  switch (state) {
    case ReviewState.APPROVED:
      return `${name} approved these changes`
    case ReviewState.CHANGES_REQUESTED:
      return `${name} requested changes`
    case ReviewState.COMMENTED:
      return `${name} left review comments`
    case ReviewState.DISMISSED:
      return `${name} ${dismissedReviewLabel(dismissedState)} (dismissed)`
    default:
      return `Awaiting requested review from ${name}`
  }
}

export function deferredTooltip(deferredType: DeferredType, name: string): string {
  if (deferredType === DeferredType.COPILOT) {
    return `${name} will automatically review once the pull request is marked ready for review`
  }
  return `${name} will be requested when the pull request is marked ready for review`
}

export function codeOwnerTooltip(request: PendingReviewRequest): string {
  const name = request.reviewer?.displayLogin ?? ''
  if (request.isCodeOwnerFromDelegation && request.delegatedFromTeam) {
    return `${name} is a code owner automatically assigned from ${request.delegatedFromTeam.displayLogin}`
  }
  return `${name} is a code owner`
}
